// Golf 8: günlük kontrol ve aile çemberi için uygulama metinleri. Sakin; asla alarm değil.
// POORT: moedertaalreview vóór livegang.
export const appCareTr = {
    nav: 'Kontrol ve çember',
    notForRelative: 'Bu sayfa takipçiler için değil.',
    account: 'Hesap',
    viaBoard: '(panoda evet dedi)',
    viaApp: '(uygulamada evet dedi)',
    subjectLabel: 'Her gün kim dokunuyor?',
    removed: '{label} çemberden çıkarıldı.',
    left: 'Çemberden ayrıldınız.',
    comingSoon: 'Günlük kontrol ve aile çemberi yakında geliyor. Pano, takvim ve hatırlatmalar şimdiden çalışıyor.',
    wizardSeniorLine: 'Daha sonra aile takip edecek mi? Bunu Ayarlar, Kontrol ve çember bölümünden açarsınız.',
    setupSaved: 'Kontrol hazır.',
    circleOn: 'Ailenin takip etmesine izin ver',
    personRights: '{label} için haklar',
    managerSeesAll: 'Panoyu yönetir ve her şeyi görür.',
    noReachSave: 'Biri haber alabildiğinde açabilirsiniz.',
    consentLaterWizard: 'Kontrol ancak {name} panoda evet dediğinde başlar.',
    title: 'Kontrol ve çember',
    settingsBody: "Panoda büyük bir 'Her şey yolunda' düğmesi ve uzaktan takip eden aile.",
    widgetTitle: 'Günlük kontrol',
    setupTitle: 'Böyle iletişimde kalırsınız',
    setupIntro: "{name} her gün bir kez 'Her şey yolunda' düğmesine dokunur. Dokunmazsa aile sakin bir haber alır.",
    whoUsesBoard: 'Panoyu kim kullanıyor?',
    boardSelf: 'Ben',
    boardOther: 'Başka biri',
    otherName: 'Bu kişinin adı ne?',
    otherNamePlaceholder: 'Örneğin Anne',
    ownerHidden: 'Panoda siz görünmezsiniz.',
    capacityQ: '{name} buna kendisi karar verebilir mi?',
    capacityYes: 'Evet',
    capacityNoButton: 'Hayır',
    capacityNo: 'O zaman kontrolü henüz açamayız. {name} kendisi evet diyebilmeli. Pano ve takvim normal çalışır.',
    checkInToggle: 'Günlük kontrol',
    deadline: 'En geç',
    days: 'Bu günlerde',
    dayNames: ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'],
    grace: 'Haber şu kadar sonra',
    graceMin: '{n} dakika',
    whoFollows: 'Kim göz kulak oluyor?',
    whoFollowsHint: 'Herkes bir e-posta alır. Sonra {name} panoda uygun olup olmadığını söyler.',
    inviteEmail: 'E-posta adresi',
    inviteLabel: '{name} size ne diyor?',
    inviteLabelOther: '{name} bu kişiye ne diyor?',
    addPerson: 'Bir kişi daha',
    rightAlerts: "'Her şey yolunda' gelmezse haber",
    rightAgenda: 'Takvimi görme (özel randevular hariç)',
    invite: 'Davet et',
    invited: 'Davet {email} adresine gönderildi',
    later: 'Sonra',
    disclaimerTitle: 'Acil durum servisi değildir',
    disclaimerBody: "Kontrol sakin bir haberdir, alarm değildir. Düşmeyi algılamaz ve yardım çağırmaz. Mesaj olmaması her zaman her şeyin yolunda olduğu anlamına gelmez. Acil durumda 112'yi arayın.",
    disclaimerCheck: 'Bunun bir acil durum servisi olmadığını anlıyorum.',
    selfConsentNow: 'Panoyu kendiniz kullandığınız için evetinizi burada soruyoruz.',
    otherConsentLater: '{name} ilk seferde panoda bunun uygun olup olmadığını söyler. O zamana kadar haber gitmez.',
    finish: 'Tamam',
    save: 'Kaydet',
    saved: 'Kaydedildi',
    cancel: 'İptal',
    enable: 'Aç',
    disable: 'Kapat',
    reachTitle: 'Kim haber alır?',
    reachOk: '{m} kişiden {n} kişi şu an haber alır.',
    reachNone: 'Şu an kimse haber almıyor.',
    reachNeedsInstall: '{label} önce AMUMIN’i ana ekrana eklemeli.',
    reachNoPush: '{label} bildirimleri henüz açmadı.',
    reachFailed: 'Son haber ulaşmadı: {label}.',
    reachEnableFirst: 'Önce telefonunuzda bildirimleri açın. Sonra kontrolü açabilirsiniz.',
    noReachInvited: 'Henüz kimse haber alamıyor: {names} daveti henüz kabul etmedi. Sonra kontrolü açabilirsiniz.',
    noReachYourYes: 'Henüz kimse haber alamıyor: {names} sizin evetinizi bekliyor (Bugün sayfasının en üstünde). Sonra kontrolü açabilirsiniz.',
    noReachTheirYes: 'Henüz kimse haber alamıyor: {names}, {name} panoda evet desin diye bekliyor.',
    noReachPush: 'Henüz kimse haber alamıyor: {names} önce bildirimleri açmalı. Sonra kontrolü açabilirsiniz.',
    noReachSelf: 'Henüz kimse haber alamıyor. Takip edecek birini davet edin; o kişi daveti kabul eder ve bildirimleri açar.',
    pendingOnTitle: 'Günlük kontrol henüz kapalı',
    pendingOnReady: 'Artık biri haber alabilir ({n}/{m}). Kontrolü açabilirsiniz.',
    pendingOnButton: 'Kontrolü açın',
    pendingOnDone: 'Günlük kontrol açık.',
    pushEnable: '{name} evinin bildirimlerini bu telefonda aç',
    pushOpen: 'Bildirimleri ayarla',
    iosInstall: "iPhone'da: Paylaş'a, ardından 'Ana Ekrana Ekle'ye dokunun ve AMUMIN'i oradan açın.",
    waitConsent: 'Panoda {name} evet diyene kadar bekleniyor.',
    declined: '{name} istemiyor. {date} tarihinden sonra tekrar sorabilirsiniz.',
    askAgain: 'Panoda tekrar sor',
    activeSince: '{date} tarihinden beri açık',
    stoppedGone: '{name} artık bu hanede değil. Kontrol kapalı.',
    stoppedBySelf: 'Günlük kontrol kapatıldı ({name}). Yeniden sorulmasını isteyebilirsin.',
    orphanTitle: 'Artık hiçbir haneye bağlı değilsin',
    orphanBody: 'Artık kimseye göz kulak olmuyorsun ve hiçbir hanenin üyesi değilsin. Hesabın sen silene kadar kalır.',
    orphanAccount: 'Hesap',
    orphanLogout: 'Çıkış yap',
    stateDone: "{name} saat {time}'da 'Her şey yolunda' düğmesine dokundu.",
    stateWaiting: 'Henüz değil. En geç {time}.',
    stateDue: 'Henüz değil. {name} hâlâ dokunabilir.',
    stateMissing: "Bugün {name} henüz 'Her şey yolunda' demedi.",
    stateMissingEarlier: "Dün ({date}) {name} 'Her şey yolunda' demedi.",
    stateBoardOffline: 'Pano {time} saatinden beri çevrimdışı, {name} dokunamıyor olabilir.',
    stateNoBoard: 'Bağlı pano yok.',
    stateResolved: "Her şey yolundaymış: {name} saat {time}'da dokundu.",
    stateResolvedOffline: "Her şey yolundaymış: {name} saat {time}'da dokundu (pano çevrimdışıydı).",
    stateResolvedManual: '{label}: her şey yolunda ({time}).',
    stateNotChecked: 'Bugün kontrol edemedik (AMUMIN arızası). Lütfen kendiniz bir haber alın.',
    stateDegraded: 'Şu an kontrol etmiyoruz (arıza).',
    statePaused: '{date} dahil duraklatıldı ({label} tarafından).',
    stateOff: 'Kontrol kapalı.',
    stateNotToday: 'Bugün kontrol yok.',
    stateConsentNeeded: 'Panoda {name} evet diyene kadar bekleniyor.',
    stateDeclined: '{name} istemiyor.',
    silenceNote: 'Mesaj olmaması her zaman her şeyin yolunda olduğu anlamına gelmez.',
    emergencyNote: 'Acil durum servisi değildir. Acil durumda: 112.',
    ack: 'Ben arıyorum',
    acked: '{label} arıyor ({time})',
    ackStale: '{label} {time} saatinden beri arıyor, henüz onaylanmadı.',
    resolve: 'Her şey yolunda',
    tzNote: '({name} için saat)',
    history: 'Son {n} gün',
    historyKinds: {
        done: 'Her şey yolunda',
        late: 'Sonra dokundu',
        missing: 'Dokunma yok',
        paused: 'Duraklatıldı',
        not_checked: 'Kontrol edilmedi',
        off: 'Kontrol yok',
    },
    pauses: 'Duraklatmalar',
    pauseAdd: 'Duraklatma ekle',
    pauseFrom: 'Başlangıç',
    pauseTo: 'Bitiş (dahil)',
    pauseMax: 'En fazla {n} gün. Daha uzun mu? O zaman kontrolü kapatın.',
    inviteInUse: 'Bu adresin ev arkadaşı olarak zaten bir daveti var. Önce onu geri çekin.',
    pauseLimit: 'Takip eden biri toplamda en fazla {n} gün ara verebilir ve en fazla {n} gün ileriye.',
    someone: 'biri',
    pauseHint: 'Örneğin tatilde veya misafirlikte. Bir neden saklamıyoruz.',
    pauseLine: '{from} ile {to} arası ({label} tarafından)',
    pauseStop: 'Duraklatmayı bitir',
    pauseNone: 'Planlanmış duraklatma yok.',
    offlineTitle: 'Pano çevrimdışıysa ne olur?',
    offlineHelp: 'Panonun bağlantısı yoksa dokunma daha sonra gider. {name} telefondaki uygulamayı da kullanabilir.',
    outageTitle: 'AMUMIN arızalıysa ne olur?',
    outageHelp: "AMUMIN arızalıysa burada 'Bugün kontrol edilmedi' görürsünüz. Mesaj olmaması her şeyin yolunda olduğunun kanıtı değildir.",
    circleTitle: 'Çember',
    circleEmpty: 'Henüz kimse takip etmiyor.',
    circleStatusInvited: 'Davet edildi',
    circleStatusPending: '{name} evet diyene kadar bekliyor',
    circleStatusActive: 'Etkin',
    circleStatusDeclined: 'İstemiyor',
    roleRelative: 'Takipçi',
    roleManager: 'Yönetici',
    remove: 'Çemberden çıkar',
    removeConfirm: '{label} çemberden çıkarılsın mı? {label} hemen hiçbir şey göremez.',
    removePauseNote: '{label} {date} tarihine kadar ara verdi. {label} çıkarılınca bu ara biter.',
    leave: 'Çemberden ayrıl',
    leaveConfirm: 'Çemberden ayrılınsın mı? {name} evinden artık hiçbir şey görmezsiniz.',
    resend: 'Tekrar gönder',
    rightsNeedYes: 'Daha fazla hak mı? O zaman {name} önce panoda evet demeli.',
    newWatcher: '{label} artık takip ediyor: {rights}.',
    inviteSomeone: 'Birini davet et',
    seniorNoCircle: 'Henüz haber alabilecek kimse yok.',
    switchToCare: "'Takip eden aileyle evde' olur",
    selfButton: 'Her şey yolunda',
    selfConsentIntro: 'Bunu sakince okuyun. Siz karar verirsiniz.',
    selfWithdraw: 'Kontrolü bırak',
    approveTitle: '{label} takip etmek istiyor',
    approveYes: 'Evet, olur',
    approveNo: 'Tercih etmem',
    myCircleTitle: 'Çemberim',
    myRights: '{name} evinde gördükleriniz',
    myRightsNone: 'Henüz hiçbir şey görmüyorsunuz: önce {name} panoda evet der.',
    pushCheckIn: 'Günlük kontrol',
    pushCheckInQuiet: 'Sessiz saatlerde de (yoksa haber sessiz saatlerden sonra gelir)',
    inviteTitle: 'Takip daveti',
    inviteBody: '{inviter} sizi {household} hanesini "{label}" olarak takip etmeye davet ediyor.',
    inviteRights: 'Şunları yapabilirsiniz:',
    inviteAcceptExisting: 'Kabul et',
    inviteLoginFirst: 'Önce {email} ile giriş yapın, sonra bağlantıyı tekrar açın.',
    inviteAcceptNew: 'Hesap oluştur ve kabul et',
    invitePassword: 'Bir şifre seçin',
    inviteWrongEmail: 'Bu davet başka bir e-posta adresi için.',
    inviteInvalid: 'Bu davet geçersiz veya süresi dolmuş.',
    inviteAccepted: 'Tamamlandı. Pano önce bunun uygun olup olmadığını sorar. Sonra burada görürsünüz.',
    inviteToApp: 'Uygulamaya git',
    notEmergencyShort: 'Bu bir acil durum servisi değildir.',
    errorGeneric: 'Olmadı. Lütfen tekrar deneyin.',
};
//# sourceMappingURL=careApp.tr.js.map